module.exports = __webpack_public_path__ + "static/media/IFS.d64d3fdf.jpg";